import {useContext, useEffect, useState} from "react";
import {Context} from "../component/context";
import {Get} from "component/const/Get";
import {filter} from "component/const/Functions";
import {ListTable} from "../component/ListTable";

export const TestGrading = () => {
    const {search} = useContext(Context);
    const [test, setTest] = useState(null)
    const [data, setData] = useState(null)
    useEffect(()=>{
        Get(`list_test_grade`)
            .then(res=>setTest(res))
    },[])

    useEffect(() => {
        setData(filter(test, search))
    }, [test, search]);

    return <ListTable data={data}/>
}